<div class="container">
    <div class="config-tab-title-area">
        <smart-icon name="visualization" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">VISUALIZATION SETTINGS</span>
    </div>
    <div class="title-item first-title-item">
        <span class="subtitle">GRID SETTINGS</span>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showGridLines" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Grid Lines</span>
        </label>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showColumnHeaders" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Column Headers</span>
        </label>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showRowBackground" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Row Background </span>
        </label>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showTableBorder" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Table Border</span>
        </label>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showGroupingPanel" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Grouping Panel</span>
        </label>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.showItemCount" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Show Item Count</span>
        </label>
    </div>
    <div class="title-item">
        <span class="subtitle">COLUMN SIZE</span>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.automaticSizing" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Automatic Sizing</span>
        </label>
    </div>
    <div class="setting-item item-level-2">
        <tam-radio value="autoSize" [(ngModel)]="settings.columnWithShowType" [disabled]="!settings.automaticSizing"
            (click)="updateGridSettions()">
        </tam-radio>
        <span class="tam-form-label body-1 item-radio">Auto-Size All</span>
    </div>
    <div class="setting-item item-level-2">
        <tam-radio value="autoSizeSkipHeader" [(ngModel)]="settings.columnWithShowType"
            [disabled]="!settings.automaticSizing" (click)="updateGridSettions()"></tam-radio>
        <span class="tam-form-label body-1 item-radio">Auto-Size All (Skip Header)</span>
    </div>
    <div class="setting-item item-level-2">
        <tam-radio value="sizeToFit" [(ngModel)]="settings.columnWithShowType" [disabled]="!settings.automaticSizing"
            (click)="updateGridSettions()">
        </tam-radio>
        <span class="tam-form-label body-1 item-radio">Size to Fit</span>
    </div>
    <div class="title-item">
        <span class="subtitle">PRINT SETTINGS</span>
    </div>
    <div class="setting-item">
        <label tam-checkbox [(ngModel)]="settings.pageBreak" (click)="updateGridSettions()">
            <span class="tam-form-label body-1">Page Break after Tile</span>
        </label>
    </div>
</div>